import { gql } from '@apollo/client';

export const MARCAR_LIDA = gql`
  mutation vizualizar($ids: [String]) {
    visualizou(ids: $ids)
  }
`;
